/** Validate and normalize an IANA timezone string. */
export function sanitizeTimezone(tz) {
  const s = String(tz || '').trim();
  if (!s || s.length > 64) return 'UTC';
  try {
    Intl.DateTimeFormat(undefined, { timeZone: s });
    return s;
  } catch {
    return 'UTC';
  }
}

/** Browser helper (client-only). */
export function detectClientTimezone() {
  try {
    return sanitizeTimezone(Intl.DateTimeFormat().resolvedOptions().timeZone);
  } catch {
    return 'UTC';
  }
}

/** IANA date YYYY-MM-DD in the given timezone. */
export function localDateKey(date = new Date(), timezone = 'UTC') {
  return new Intl.DateTimeFormat('en-CA', { timeZone: sanitizeTimezone(timezone) }).format(
    new Date(date)
  );
}

/** Add calendar days to a YYYY-MM-DD key (date-only arithmetic). */
export function addLocalDateKey(key, deltaDays) {
  const [y, m, d] = String(key || '').split('-').map(Number);
  if (!y || !m || !d) return String(key || '');
  const next = new Date(Date.UTC(y, m - 1, d + Number(deltaDays), 12, 0, 0));
  return `${next.getUTCFullYear()}-${String(next.getUTCMonth() + 1).padStart(2, '0')}-${String(next.getUTCDate()).padStart(2, '0')}`;
}

/** Prefer explicit body value, then stored user profile, then request header. */
export function resolveRequestTimezone(req, userDoc, bodyTimezone) {
  if (bodyTimezone != null && String(bodyTimezone).trim()) {
    return sanitizeTimezone(bodyTimezone);
  }
  if (userDoc?.timezone) {
    return sanitizeTimezone(userDoc.timezone);
  }
  const header = req?.headers?.['x-user-timezone'] || req?.headers?.['X-User-Timezone'];
  if (header) return sanitizeTimezone(header);
  return 'UTC';
}
